import { MutationCache, QueryClient } from '@tanstack/react-query';

export const createAdminQueryClient = (reportMutationError: (message: string) => void) => new QueryClient({
  mutationCache: new MutationCache({
    // Every write failure needs visible feedback; individual pages only own success recovery.
    onError: (error) => reportMutationError(error instanceof Error ? error.message : '操作失败，请稍后重试')
  }),
  defaultOptions: {
    queries: { staleTime: 20_000, retry: 1, refetchOnWindowFocus: false }
  }
});
